module.exports = __webpack_public_path__ + "img/skillsA-3.ceb2ceb8.png";